import { VcodeOperation } from '@shopee-user/otp-constants';
import { ClientID } from '@shopee-user/authentication-redirect';
import { loginByPasswordURL } from '@shopee-user/url';

const REDIRECT_CLIENT_ID = ClientID.SPXInternal;
const AUTHENTICATION_ENTRY_URL = loginByPasswordURL.getUrl();
export { REDIRECT_CLIENT_ID, AUTHENTICATION_ENTRY_URL };

const INTERNAL_REDIRECT_CLIENT_ID = ClientID.SPXInternal;
const EXTERNAL_REDIRECT_CLIENT_ID = ClientID.SPXSeller;
export { INTERNAL_REDIRECT_CLIENT_ID, EXTERNAL_REDIRECT_CLIENT_ID };

export {
  AUTHENTICATE_CONTACT_US_LINK,
  AUTHENTICATE_HELP_LINK,
  ONE_CREDENTIAL_RECLAIM_PHONE_FAILED_HELP_LINK,
  SIGNUP_HELP_LINK,
  ACCOUNT_SUSPENDED_HELP_LINK,
  RESET_PASSWORD_INFO_LINK,
  RESET_PASSWORD_CONTACT_US_LINK,
  USER_ACCOUNT_CONTACT_US_LINK,
  LOGIN_FRAUD_CONTACT_US_LINK,
  CHANGE_PHONE_HELP_LINK,
  TERMS_OF_SERVICE_LINK,
  PRIVACY_POLICY_LINK,
  COOKIE_POLICY_LINK,
  PHONE_OR_EMAIL_LINKED_CONTACT_US_LINK,
  ACCOUNT_DELETE_IOS_LINK,
  ACCOUNT_DELETE_ANDROID_LINK,
  CHANGE_PHONE_NATIVE_VERIFICATION_LINK,
  TOC_ACCOUNT_CONTACT_US_LINK,
  TERMS_OF_SERVICE_WEBVIEW_LINK,
  PRIVACY_POLICY_WEBVIEW_LINK,
  DATA_PROTECTION_POLICY_LINK,
  PLATFORM_PARTNER_RULES_LINK,
} from './customerServicesUrl';

export { IvsEventType, IVS_BASE_URL, IVS_BASE_REGEX } from './ivs';

export {
  SHOPEE_PRIVACY_POLICY_LINK,
  SHOPEE_TERMS_OF_SERVICE_LINK,
  SHOPEE_HOMEPAGE_LINK,
  EXTERNAL_HOMEPAGE_LINK,
} from '@shopee-user/shared-customization-logic';

export const OtpOperation = {
  LoginOTP: VcodeOperation.TOB_ACCOUNT_SPX_SELLER_OTP_LOGIN,
  LoginPassword:
    VcodeOperation.TOB_ACCOUNT_SPX_SELLER_PASSWORD_NEW_DEVICE_LOGIN,
  MigrateOneCredential:
    VcodeOperation.TOB_ACCOUNT_SPX_SELLER_MIGRATE_ONE_CREDENTIAL,
  ForgotPassword: VcodeOperation.TOB_ACCOUNT_SPX_SELLER_FORGET_PASSWORD,
  SignupOTP: VcodeOperation.TOB_ACCOUNT_SPX_SELLER_OTP_SIGNUP,
  AddPhone: VcodeOperation.TOB_ACCOUNT_SPX_SELLER_ADD_PHONE,
  ChangePhone: VcodeOperation.NOT_APPLICABLE,
  AddEmail: VcodeOperation.TOB_ACCOUNT_SPX_SELLER_ADD_EMAIL,
  ChangeEmail: VcodeOperation.NOT_APPLICABLE,
  SwitchToCLinkOneCredential: VcodeOperation.NOT_APPLICABLE,
  OneCredentialDelinkOTP:
    VcodeOperation.TOB_ACCOUNT_SPX_SELLER_ONE_CREDENTIAL_DELINK_OTP,
};
